var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            title: _vm.$t("chats.administrative-chat"),
            okBtnText: _vm.$t("create"),
            okBtnVariant: "success",
            cancelBtnText: _vm.$t("back"),
            cancelBtnVariant: "secondary",
            okFn: _vm.createChatUser.value
              ? function() {
                  _vm.createChat()
                }
              : null,
            cancelFn: function() {
              _vm.$emit("toggleShowAdministrativeChat")
            }
          },
          model: {
            value: _vm.showDialog,
            callback: function($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog"
          }
        },
        [
          [
            _c("div", [
              _vm.userTypeChatProf
                ? _c("span", [_vm._v(_vm._s(_vm.$t("professional")))])
                : _c("span", [_vm._v(_vm._s(_vm.$t("patient")))])
            ]),
            _vm._v(" "),
            _c("base-select", {
              attrs: {
                searchable: "",
                clearable: "",
                avoidDefaultSort: "",
                loading: _vm.createChatUser.loading,
                options: _vm.createChatUser.options,
                valueProp: "id",
                label: "name",
                placeholder: _vm.userTypeChatProf
                  ? _vm.$t("chats.select-prof")
                  : _vm.$t("chats.select-patient")
              },
              on: {
                search: function($event) {
                  _vm.userTypeChatProf
                    ? _vm.searchProfByName($event)
                    : _vm.searchPatientByName($event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function(data) {
                    return [
                      _c("div", [
                        _c("img", {
                          staticClass: "photo-option",
                          attrs: {
                            src: _vm.getUserPhoto(
                              _vm.createChatUser.options,
                              data.option.value
                            ),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(data.option.label))])
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.createChatUser.value,
                callback: function($$v) {
                  _vm.$set(_vm.createChatUser, "value", $$v)
                },
                expression: "createChatUser.value"
              }
            }),
            _vm._v(" "),
            _vm.createChatUser.value
              ? _c("base-textarea", {
                  staticClass: "mt-2",
                  attrs: {
                    rows: 1,
                    "max-rows": 5,
                    placeholder: _vm.$t("chats.new-message")
                  },
                  model: {
                    value: _vm.newMessage,
                    callback: function($$v) {
                      _vm.newMessage = $$v
                    },
                    expression: "newMessage"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.createChatUser.value && !_vm.userTypeChatProf
              ? _c("attach-file")
              : _vm._e(),
            _vm._v(" "),
            _vm.createChatUser.value && _vm.userTypeChatProf
              ? _c("base-select", {
                  attrs: {
                    searchable: "",
                    clearable: "",
                    avoidDefaultSort: "",
                    loading: _vm.interconsultationPatient.loading,
                    options: _vm.interconsultationPatient.options,
                    valueProp: "id",
                    label: "name",
                    placeholder: _vm.$t("chats.select-patient")
                  },
                  on: {
                    search: function($event) {
                      return _vm.searchPatientByName($event)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function(data) {
                          return [
                            _c("div", [
                              _c("img", {
                                staticClass: "photo-option",
                                attrs: {
                                  src: _vm.getUserPhoto(
                                    _vm.interconsultationPatient.options,
                                    data.option.value
                                  ),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(data.option.label))])
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4203853806
                  ),
                  model: {
                    value: _vm.interconsultationPatient.value,
                    callback: function($$v) {
                      _vm.$set(_vm.interconsultationPatient, "value", $$v)
                    },
                    expression: "interconsultationPatient.value"
                  }
                })
              : _vm._e()
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0016e43a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0016e43a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/chat-interconsultations/AdministrativeChatModal.vue
// module id = 3975
// module chunks = 14